import { ApiClient } from 'ApiClient';
import { ReservationSpecialDay } from 'interfaces';

class ReservationSpecialDayService {
  public async getAll(): Promise<ReservationSpecialDay[]> {
    return ApiClient.get<ReservationSpecialDay[]>('reservation-special-days');
  }

  public create(data: any) {
    return ApiClient.post('reservation-special-days', data);
  }

  public update(id: number, data: any) {
    return ApiClient.put(`reservation-special-days/${id}`, data);
  }

  public remove(id: number) {
    return ApiClient.delete(`reservation-special-days/${id}`);
  }
}

const singleton = new ReservationSpecialDayService();
export { singleton as ReservationSpecialDayService };
